/* eslint-disable react/jsx-props-no-spreading */
import {
  BulletList,
  type BulletListProps,
  BulletListVariants,
  Spacer,
  type SpacerProps,
} from "@polestar/component-warehouse-react";
import React, { type FC } from "react";

/**
 * Used for keeping ordered list styles consistent between the simple content (HTML string) documents
 * and structured text content (DAST) documents.
 */
const ContentOrderedList: FC<
  BulletListProps & Pick<SpacerProps, "spacing">
> = ({ children, spacing, ...props }) => {
  return (
    <>
      <BulletList as="ol" variant={BulletListVariants.numbered} {...props}>
        {children}
      </BulletList>
      {spacing && <Spacer spacing={spacing} />}
    </>
  );
};

export default ContentOrderedList;
